import { render } from "./StyledUploader.vue?vue&type=template&id=4be63a9e&ts=true"
import script from "./StyledUploader.vue?vue&type=script&lang=ts"
export * from "./StyledUploader.vue?vue&type=script&lang=ts"

import "./StyledUploader.vue?vue&type=style&index=0&id=4be63a9e&lang=scss"

import exportComponent from "/usr/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.0.11_vue@3.2.47_webpack@4.44.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__